export default __webpack_public_path__ + "static/media/warn.591a5556.wav";